import {
  Intercom,
  showMessages,
  shutdown,
  startSurvey,
  update,
} from '@intercom/messenger-js-sdk';

type IntercomSettings = Parameters<typeof Intercom>[0];
type IntercomUserUpdate = Parameters<typeof update>[0];

let isIntercomInitialized = false;

const getBaseSettings = (): IntercomSettings | null => {
  const appId = import.meta.env.VITE_INTERCOM_APP_ID;

  if (!appId) {
    return null;
  }

  return {
    app_id: appId,
    hide_default_launcher: true,
    theme_mode: 'system',
  };
};

export const ensureIntercomBooted = () => {
  if (typeof window === 'undefined' || isIntercomInitialized) {
    return isIntercomInitialized;
  }

  const settings = getBaseSettings();

  if (!settings) {
    return false;
  }

  Intercom(settings);
  isIntercomInitialized = true;

  return true;
};

export const updateIntercomUser = (user: IntercomUserUpdate) => {
  if (!ensureIntercomBooted()) {
    return false;
  }

  update(user);

  return true;
};

export const showIntercomMessages = () => {
  if (!ensureIntercomBooted()) {
    return false;
  }

  showMessages();

  return true;
};

export const startIntercomSurvey = (surveyId: string) => {
  if (!ensureIntercomBooted()) {
    return false;
  }

  startSurvey(surveyId);

  return true;
};

export const shutdownIntercomSession = () => {
  shutdown();
  isIntercomInitialized = false;
};
